import { parse as URIParse, serialize as URISerialize } from 'uri-js';
import { isLocal, getUrlParams } from '@utils/tools';

// 域名白名单
const HOST_WHITE_LIST = ['meituan.com', 'sankuai.com'];
// 本地开发环境加上localhost以及本地ip
if (isLocal()) {
  HOST_WHITE_LIST.unshift('localhost');
  // HOST_WHITE_LIST.unshift('11.39.111.60');
}

// 允许的协议白名单
const ALLOWED_SCHEMES = ['http:', 'https:'];

// host是否在域名白名单里
function isInWhiteListOfHostFn(url = '') {
  try {
    if (url.startsWith('/')) return true;
    const urlObj = new URL(url, window.location.origin);

    // 校验协议类型，只允许 http 或 https，防止 javascript:、data: 等 XSS 攻击
    if (!ALLOWED_SCHEMES.includes(urlObj.protocol)) {
      return false;
    }
    // 精确匹配域名或子域名，防止 evil-meituan.com 等绕过白名单
    const hostname = urlObj.hostname.toLowerCase();
    return HOST_WHITE_LIST.some((item) => hostname === item || hostname.endsWith(`.${item}`));
  } catch (err) {
    console.error(err);
    return false;
  }
}
interface IAddQueryOpts {
  isCheckUrlHost?: boolean;
}
const DEFAULT_COPY_QUERY_LIST = ['token', 'staffSsoId'];
// 将当前url的一些参数设置到即将跳转的url上
function appendQuery2TargetUrlFromCurrentUrl(url = '', currentUrl?: string, opts?: IAddQueryOpts) {
  const { isCheckUrlHost = true } = opts || {};
  if (!url) {
    url = '';
  }
  if (!currentUrl) {
    currentUrl = window.location.href;
  }
  try {
    // 检查跳转的url host是否在白名单
    if (isCheckUrlHost && url) {
      const isWhiteHost = isInWhiteListOfHostFn(url);
      if (!isWhiteHost) return '';
    }
    const urlObj = URIParse(url);
    const currentUrlQueryObj = getUrlParams(currentUrl);
    const addList = [];
    // 获取需要追加的query
    DEFAULT_COPY_QUERY_LIST.forEach((item) => {
      if (currentUrlQueryObj[item]) {
        // @ts-ignore
        addList.push(`${item}=${currentUrlQueryObj[item]}`);
      }
    });
    // 追加query到目标url
    if (addList.length > 0) {
      urlObj.query = `${urlObj.query ? `${urlObj.query}&` : ''}${addList.join('&')}`;
    }
    return URISerialize(urlObj);
  } catch (err) {
    return '';
  }
}
export { isInWhiteListOfHostFn, appendQuery2TargetUrlFromCurrentUrl };
